import React from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import { CheckCircle2, Brain, Zap, Trophy } from 'lucide-react';
export function ProductSection() {
  const {
    ref,
    isVisible
  } = useScrollAnimation();
  return <section className="w-full bg-offwhite py-24 px-4 sm:px-6 lg:px-8" data-id="element-136">
      <div ref={ref} className={`max-w-5xl mx-auto transition-all duration-1000 transform ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-137">
        <div className="text-center mb-16" data-id="element-138">
          <span className="inline-block font-montserrat font-bold text-gold text-sm tracking-widest uppercase mb-4" data-id="element-139">
            LO QUE VAS A RECIBIR HOY
          </span>
          <h2 className="font-playfair font-bold text-3xl sm:text-[44px] leading-[1.2] text-navy" data-id="element-140">
            El Sistema Completo de
            <br data-id="element-141" />
            Independencia Docente
          </h2>
        </div>

        {/* Main Product Card */}
        <div className="bg-white rounded-[20px] shadow-[0_8px_40px_rgba(0,0,0,0.1)] border-l-4 border-gold p-8 sm:p-12 mb-12 relative overflow-hidden" data-id="element-142">
          <div className="absolute top-0 right-0 bg-gold/10 text-navy font-montserrat font-bold text-xs px-4 py-2 rounded-bl-lg" data-id="element-143">
            📘 PRODUCTO PRINCIPAL
          </div>

          <div className="flex flex-col md:flex-row gap-8 items-start" data-id="element-144">
            {/* Book Image */}
            <div className="w-full md:w-56 flex-shrink-0 flex justify-center" data-id="element-145">
              <img src="https://cdn.magicpatterns.com/uploads/aL7D49DHrhG3zbFqTRNDQq/ChatGPT_Image_1_mar_2026,_02_21_01.png" alt="IA Práctica para Docentes" className="w-48 md:w-full h-auto drop-shadow-[0_8px_24px_rgba(0,0,0,0.15)]" data-id="element-146" />
            </div>

            <div className="flex-1" data-id="element-147">
              <h3 className="font-playfair font-bold text-2xl sm:text-[32px] text-navy mb-4 leading-tight" data-id="element-148">
                Manual Completo
                <br data-id="element-149" />
                IA Práctica para Docentes
              </h3>
              <p className="font-inter text-gray-600 text-lg mb-8 max-w-2xl" data-id="element-150">
                Un sistema estructurado en módulos donde aprendés exactamente
                cómo usar la IA para crear material pedagógico de alta calidad.
                Para cualquier nivel, cualquier materia, cualquier momento.
              </p>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-151">
                {['Cómo usar correctamente ChatGPT, Gemini y herramientas de IA', 'Cómo crear planificaciones anuales y mensuales adaptadas a tu realidad', 'Cómo generar actividades dinámicas y diferenciadas por nivel', 'Cómo diseñar evaluaciones completas con rúbricas automáticas', 'Cómo mejorar respuestas mediocres de la IA con técnicas avanzadas', 'Cómo ahorrar entre 5 y 10 horas por semana garantizado'].map((feature, idx) => <div key={idx} className="flex items-start gap-3" data-id="element-152">
                    <CheckCircle2 className="text-emerald flex-shrink-0 mt-0.5" size={20} data-id="element-153" />
                    <span className="font-inter font-medium text-gray-700 text-[15px] leading-snug" data-id="element-154">
                      {feature}
                    </span>
                  </div>)}
              </div>

              <div className="mt-6 pt-6 border-t border-gray-100" data-id="element-155">
                <span className="font-inter text-sm text-gray-500" data-id="element-156">
                  Valor Real:{' '}
                </span>
                <span className="font-montserrat font-bold text-xl text-gray-400 line-through decoration-red-500 decoration-2" data-id="element-157">
                  $35.000
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Bonus Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-158">
          {/* Bonus 1 */}
          <div className="bg-white rounded-2xl shadow-[0_4px_24px_rgba(0,0,0,0.08)] overflow-hidden hover:scale-[1.02] transition-transform duration-300 flex flex-col h-full" data-id="element-159">
            <div className="bg-gold h-[60px] flex items-center justify-center" data-id="element-160">
              <span className="font-montserrat font-bold text-navy text-sm tracking-wider" data-id="element-161">
                🎁 BONUS 1 — GRATIS
              </span>
            </div>
            <div className="p-6 flex-1 flex flex-col" data-id="element-162">
              <div className="flex justify-center mb-4" data-id="element-163">
                <img src="https://cdn.magicpatterns.com/uploads/5wAV9iTyr9C9hvFh6LKA74/ChatGPT_Image_1_mar_2026,_02_21_08.png" alt="Banco Universal de Prompts Docentes Inteligentes" className="w-36 h-auto drop-shadow-[0_4px_12px_rgba(0,0,0,0.12)]" data-id="element-164" />
              </div>
              <h4 className="font-playfair font-bold text-xl text-navy mb-3 leading-tight" data-id="element-165">
                Banco Universal de Prompts Docentes Inteligentes
              </h4>
              <p className="font-inter text-sm text-gray-600 mb-6 flex-1" data-id="element-166">
                Sistema completo de prompts adaptables para ChatGPT, Gemini y
                Gamma. Planificaciones, secuencias, evaluaciones, rúbricas y
                adaptaciones por inclusión.
              </p>
              <div className="pt-4 border-t border-gray-100" data-id="element-167">
                <span className="font-inter text-sm text-gray-400 line-through" data-id="element-168">
                  Valor: $12.000
                </span>
              </div>
            </div>
          </div>

          {/* Bonus 2 */}
          <div className="bg-white rounded-2xl shadow-[0_4px_24px_rgba(0,0,0,0.08)] overflow-hidden hover:scale-[1.02] transition-transform duration-300 flex flex-col h-full" data-id="element-169">
            <div className="bg-electric h-[60px] flex items-center justify-center" data-id="element-170">
              <span className="font-montserrat font-bold text-white text-sm tracking-wider" data-id="element-171">
                🎁 BONUS 2 — GRATIS
              </span>
            </div>
            <div className="p-6 flex-1 flex flex-col" data-id="element-172">
              <div className="flex justify-center mb-4" data-id="element-173">
                <img src="https://cdn.magicpatterns.com/uploads/4Vd4sKNHiKGFTSSgbuKT6c/ChatGPT_Image_1_mar_2026,_02_21_12.png" alt="Sistema Planificación 10X Paso a Paso" className="w-36 h-auto drop-shadow-[0_4px_12px_rgba(0,0,0,0.12)]" data-id="element-174" />
              </div>
              <h4 className="font-playfair font-bold text-xl text-navy mb-3 leading-tight" data-id="element-175">
                Sistema "Planificación 10X" Paso a Paso
              </h4>
              <p className="font-inter text-sm text-gray-600 mb-6 flex-1" data-id="element-176">
                De la idea básica a la planificación completa en 10-15 minutos.
                Flujo de trabajo optimizado + material imprimible incluido.
              </p>
              <div className="pt-4 border-t border-gray-100" data-id="element-177">
                <span className="font-inter text-sm text-gray-400 line-through" data-id="element-178">
                  Valor: $9.000
                </span>
              </div>
            </div>
          </div>

          {/* Bonus 3 */}
          <div className="bg-white rounded-2xl shadow-[0_4px_24px_rgba(0,0,0,0.08)] overflow-hidden hover:scale-[1.02] transition-transform duration-300 flex flex-col h-full" data-id="element-179">
            <div className="bg-emerald h-[60px] flex items-center justify-center" data-id="element-180">
              <span className="font-montserrat font-bold text-white text-sm tracking-wider" data-id="element-181">
                🎁 BONUS 3 — GRATIS
              </span>
            </div>
            <div className="p-6 flex-1 flex flex-col" data-id="element-182">
              <div className="flex justify-center mb-4" data-id="element-183">
                <img src="https://cdn.magicpatterns.com/uploads/sZbtw1nBXqHaHGLF26pHj4/ChatGPT_Image_1_mar_2026,_02_21_16.png" alt="Creá tu Propio Material Digital" className="w-36 h-auto drop-shadow-[0_4px_12px_rgba(0,0,0,0.12)]" data-id="element-184" />
              </div>
              <h4 className="font-playfair font-bold text-xl text-navy mb-3 leading-tight" data-id="element-185">
                Creá tu Propio Material y Nunca Más Comprés PDFs Ajenos
              </h4>
              <p className="font-inter text-sm text-gray-600 mb-6 flex-1" data-id="element-186">
                Aprendé a evaluar, mejorar y construir tu banco personal de
                recursos. Independencia profesional total y permanente.
              </p>
              <div className="pt-4 border-t border-gray-100" data-id="element-187">
                <span className="font-inter text-sm text-gray-400 line-through" data-id="element-188">
                  Valor: $8.000
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}